import * as PIXI_SPINE from 'pixi-spine';

import * as spineCore from '@pixi-spine/runtime-4.1';

const BaseSpine = PIXI_SPINE.Spine;
export { BaseSpine, spineCore };
